<template>
<div>
  <div class="columns">
    <div class="column">
      <div v-if="finding.vulnerability">
        <p class="lh-1">
          {{ finding.vulnerability.cvid }} <span class="has-text-danger">{{ finding.vulnerability.cvss }}</span>
          <br>
          {{ finding.vulnerability.severity }}
          <br>
          <small>{{ finding.created_at | asCalendar }}</small>
        </p>
      </div>
      <finding-output :output="finding.output"/>
    </div>
  </div>
</div>
</template>
<script>
import Attribute from '@/store/models/Attribute'
import Finding from '@/store/models/Finding'


export default {

  props: {
    finding: {
      type: Object,
      default: () => (new Attribute)
    },
  },
}
</script>
